<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="fluencyrate-box pointer"
    (clickOutside)="onClickOutside()" [additionalElementRefs]="extraBoxes">
    <div class="flag flex-column  no-select" [class.flag-all-trials]="remainingTrials<=0"  (mousedown)="startLongPress()" (mouseup)="endLongPress($event)"
        (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)"
        (touchcancel)="endLongPress($event)" (click)="openRate()" >

        <span class="badge badge-left badge-big badge-green" (click)="showExtra2()" *ngIf="rates.length>0">{{lastRate()}}</span>
        <div class="duration-container" [class.blinking-effect]="isAlarmRinging">
            <div class="duration-controls">
                <button (click)="startTimer()" class="duration-button start-button">{{timerString()}}</button>
                <button *ngIf="isStarted" (click)="stopTimer()" class="duration-button stop-button">
                    Stop
                </button>
            </div>
            <div class="flag-text">{{ text }}

                <span class="sd-text">{{target?.DiscriminativeStimulus}}</span>

            </div>
        </div>
        <span class="badge-count" (click)="showExtra2()" [class.badge-count-green]="rates.length>=expectedAmount"
            [class.badge-count-red]="rates.length<expectedAmount">{{rates.length}}/{{expectedAmount}}</span>

        <button class="badge-bottom-left" [class.target-note-new]="target?.HasUnreadTargetNoteForStaff" (click)="openDetails($event)" >?</button>
        <button class="badge-bottom-right" (click)="openDetails($event)" title="Remaining desired Trials" *ngIf="remainingTrials>0"> {{remainingTrials}}</button>
    </div>
</div>
@if (detailsOpened) {
<app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened" (click)="$event.stopPropagation()">
    <div class="extra-container-textbox">
        <div class="score-buttons">
            <button class="correct-button" (click)="incrementCount($event)">
                <span class="button-count">{{ totalCount }}</span>
                Happened
            </button>
        </div>
    </div>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
    <div class="extra-close" (click)="closeExtra2()">X</div>
    <div class="extra-container-textbox">
        <div *ngFor="let rate of rates">
            <div class="float-right extra-list-trash-icon pointer" (click)="deleteData(rate)"><i class="pi pi-trash"></i></div>
            <div>{{ rate.FormattedDate }}</div>
            <div>{{ rate.totalCount }} occurrences ({{ formattedDuration(rate.Duration) }})</div>
        </div>
    </div>
</div>
